    function initSingleProject() {

    }
